import firebase from "../../services/firebase";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { uiConfig } from "../../services/firebaseAuth";
import React, { useContext } from "react";
import { Button, Grid } from "@material-ui/core";

import { initUser } from "../../ContextProvider";

export const LoginBtn = () => (
  <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
);
export const LogoutBtn = (props) => (
  <Grid container justify="center">
    <Button
      variant="outlined"
      color="secondary"
      onClick={() => {
        firebase.auth().signOut();
        window.location.reload(true);
      }}
    >
      Sign-out
    </Button>
  </Grid>
);
